import React, { useContext } from 'react';
import styled from 'styled-components';
import { IconPlay, Text, cssColorValue, screenXxsMax, cssSpacing, } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../Contentful';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
import { transformScaleUp } from '../../utils';
import { FrodorModulesContext } from '../../../Context';
import { TWO_COLUMN_MAX_WIDTH } from '../Grid';
import { ImageWrapper } from '../ImageWrapper';
const titleClass = 'content-item-card-title';
const isVideoContentType = (contentType) => {
    return contentType === 'video' || contentType === 'videoPage';
};
export const ItemLabel = withAnimationContext(styled(Text)
    .attrs({
    variant: 'marginal',
    forwardedAs: 'p',
    weight: 'book',
})
    .withConfig({
    shouldForwardProp: prop => !['forwardedAs', 'animationContext'].includes(prop),
}) `
  ${fadeInAnimation(DELAYS.FOURTH)};
  padding-top: ${cssSpacing('looser')};
  padding-bottom: 0;
  text-transform: uppercase;
  color: ${props => props.theme.label.color};
`);
export const ItemTitle = withAnimationContext(styled(Text)
    .attrs({
    forwardedAs: 'h3',
    variant: 'titleSmall',
    className: titleClass,
})
    .withConfig({
    shouldForwardProp: prop => !['forwardedAs', 'animationContext'].includes(prop),
}) `
  padding-top: ${cssSpacing('base')};
  margin-bottom: ${cssSpacing('tighter-2')};

  ${fadeInAnimation(DELAYS.FIFTH)};

  /* when title is greater than two column, it should be truncated */
  @media (min-width: calc(${TWO_COLUMN_MAX_WIDTH} + 1px)) {
    max-height: 3.6em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

  }
`);
export const ItemText = withAnimationContext(styled(Text)
    .attrs({
    forwardedAs: 'p',
    variant: 'bodyMedium',
})
    .withConfig({
    shouldForwardProp: prop => !['forwardedAs', 'animationContext'].includes(prop),
}) `
  ${fadeInAnimation(DELAYS.SIXTH)};
  /* no description text on mobile */
  @media (max-width: ${screenXxsMax}) {
    display: none;
  }
`);
export const StyledArticle = styled.article `
  & .interactive-element {
    text-decoration: none;
    color: ${cssColorValue('textBase')};

    &:hover,
    &:focus:not(:disabled),
    &:active:not(:disabled) {
      text-decoration: none;
      & .${titleClass} {
        text-decoration: underline;
      }
      img,
      svg {
        ${transformScaleUp};
      }
      svg {
        opacity: 0.8;
      }
    }
    img,
    svg {
      transition: transform 0.3s ease-in-out;
    }
  }
`;
export const ContentItemCard = ({ item, trackCategory, placeholders = true, className, featured = false, }) => {
    const { title, url, image, contentType, description, label, linkExternal = false, } = item;
    const { InteractiveElement } = useContext(FrodorModulesContext);
    return (React.createElement(StyledArticle, { className: className },
        React.createElement(InteractiveElement, { className: "interactive-element", href: url, external: linkExternal, trackingCategory: trackCategory, trackingLabel: `Content Link - [${contentType}]: ${title}`, "aria-label": title },
            React.createElement(ImageWrapper, { video: isVideoContentType(contentType), featured: featured },
                React.createElement(ContentfulImage, { asset: image, placeholder: placeholders }, isVideoContentType(contentType) && React.createElement(IconPlay, null))),
            label && React.createElement(ItemLabel, null, label),
            title && React.createElement(ItemTitle, null, title),
            description && React.createElement(ItemText, null, description))));
};
